/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_AllocationInputs */

const en_admin_dashboard_invoice_tags_allocation = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rooms, Desks and other allocations`)
};

const de_admin_dashboard_invoice_tags_allocation = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büros, Schreibtische und weitere Zuweisungen`)
};

const es_admin_dashboard_invoice_tags_allocation = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oficinas, escritorios y otras asignaciones`)
};

const fr_admin_dashboard_invoice_tags_allocation = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureaux, Postes de travail et autres attributions`)
};

const nl_admin_dashboard_invoice_tags_allocation = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamers, bureaus en andere toewijzingen`)
};

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */
const it_admin_dashboard_invoice_tags_allocation = en_admin_dashboard_invoice_tags_allocation;

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */
const pt_br2_admin_dashboard_invoice_tags_allocation = en_admin_dashboard_invoice_tags_allocation;

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */
const pl_admin_dashboard_invoice_tags_allocation = en_admin_dashboard_invoice_tags_allocation;

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */
const hu_admin_dashboard_invoice_tags_allocation = en_admin_dashboard_invoice_tags_allocation;

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_AllocationInputs) => LocalizedString} */
const ro_admin_dashboard_invoice_tags_allocation = en_admin_dashboard_invoice_tags_allocation;

/**
* | output |
* | --- |
* | "Rooms, Desks and other allocations" |
*
* @param {Admin_Dashboard_Invoice_Tags_AllocationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_allocation = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_AllocationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_AllocationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_allocation(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_allocation(inputs)
	return ro_admin_dashboard_invoice_tags_allocation(inputs)
});
export { admin_dashboard_invoice_tags_allocation as "admin.dashboard.invoice_tags.allocation" }